import styled, { keyframes } from "styled-components"
import Image from "gatsby-image"

import { motion } from "framer-motion"
import BackgroundImage from "../../assets/portfoliobg.jpg"

export const Header = styled.div`
  margin-top: -5rem;
  padding-top: 5rem;
  padding-left: 2rem;
  height: 100vh;
  background-color: ${({ theme }) => theme.background};
  background-image: url(${BackgroundImage});
  background-blend-mode: overlay;
  position: relative;
  z-index: 5;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: linear-gradient(
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.8) 80%
    );
  }

  @media (max-width: 768px) {
    margin-top: 0rem;
    padding-top: 3rem;
    height: 100vh;
  }
`

export const Content = styled.section`
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    justify-content: center;
  }
`

const breatheAnimation = keyframes`
 0% { transform: translateY(0px)}
 50% {transform: translateY(-14px)  }
 100% {transform: translateY(0px)  }
`

export const DownArrow = styled.section`
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 30px;
  right: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  animation-name: ${breatheAnimation};
  animation-duration: 1.5s;
  animation-iteration-count: infinite;
  animation-timing-function: bounce;
  & a {
    width: 100%;
    color: var(--clr-primary-9);
    text-decoration: inherit;
  }
  & svg {
    width: 100%;
    height: 100%;
    font-size: 0.8rem;
    cursor: pointer;
  }
  @media (max-width: 500px) {
    height: 35px;
    bottom: 5px;
    right: 45%;
  }
  @media (max-width: 300px) {
    height: 30px;
    bottom: 2px;
  }
`
export const Info = styled(motion.section)`
  padding: 2rem 0;
  background: darkness(${({ theme }) => theme.body}, 150%);
  z-index: 20;
  filter: ${({ theme }) => theme === "darkTheme" && "brightness(280%)"};
`
export const Line = styled(motion.div)`
  margin-bottom: 0.5rem;
  margin-left: 0;
  width: 5rem;
  height: 0.25rem;
  background: var(--clr-primary-5);
`
export const ImageWrapper = styled(motion.div)`
  width: 50%;
  height: 100%;
  margin-right: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  background: "rgba(2, 62, 138,0.9)";
  z-index: -1;
  @media (max-width: 768px) {
    display: none;
  }
`
export const ImageStyled = styled(Image)`
  width: 300px;
  height: 300px;
  border-radius: 50%;
  border: 2px dashed ${({ theme }) => theme.fontColor};

  @media (max-width: 768px) {
    width: 200px;
    height: 200px;
  }
`

export const Title = styled(motion.h1)`
  width: 100%;
  color: var(--clr-primary-9);
  @media screen and (max-width: 350px) {
    font-size: 1.4rem;
  }
`
export const SubTitle = styled(motion.h4)`
  width: 100%;
  color: var(--clr-grey-9);
`
